export const MAX_ROWS = 5;
export const MAX_COLUMNS = 6;
